
(function() {
  var collectionBannerData = [];

  function initializeBannerData(data) {
    collectionBannerData = data;
  }

  function snizeAddCollectionBanner(snizeBannerUrl, snizeBannerPosition) {
    var $resultsContent = window.Searchanise.$('ul.snize-search-results-content');
    if ($resultsContent.length) {
      var $targetElement = $resultsContent.find(`li:nth-child(${snizeBannerPosition})`);
      if ($targetElement.length) {
        $targetElement.before(`
          <li class="snize-banner snize-custom-banner" data-position="${snizeBannerPosition}">
            <img src="${snizeBannerUrl}" alt="Collection Banner">
          </li>`);
      }
    }
  }

  function insertBanners() {
    if (collectionBannerData && collectionBannerData.length > 0) {
      collectionBannerData.forEach(function(banner) {
        if (!window.Searchanise.$(`.snize-custom-banner[data-position="${banner.bannerPosition}"]`).length) {
          snizeAddCollectionBanner(banner.bannerImage, banner.bannerPosition);
        }
      });
    }
  }

  document.addEventListener('Searchanise.Loaded', function() {
    window.Searchanise.$(document).on('Searchanise.ResultsUpdated', function () {
      setTimeout(insertBanners, 100);
    });

    setTimeout(insertBanners, 500);
  });

  // Exposer la fonction d'initialisation globalement
  window.initializeSearchaniseBanners = initializeBannerData;
})();